import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, filter } from 'rxjs';
import { CustomEventData, CustomEvents } from './custom-events';

@Injectable()
export class EventContext implements OnDestroy {
  private _actions$: Subject<{ event: CustomEvents; data: CustomEventData<CustomEvents.Unknown> }> = new Subject();

  public ngOnDestroy(): void {
    this._actions$.complete();
  }

  public dispatch<T extends CustomEvents>(event: T, data: CustomEventData<T>): void {
    this._actions$.next({ event, data });
  }

  public getEvent<T extends CustomEvents>(event: T): Observable<{ event: T; data: CustomEventData<T> }> {
    return this._actions$.asObservable().pipe(
      filter(payload => payload.event === event)
    ) as Observable<{
      event: T;
      data: CustomEventData<T>;
    }>;
  }
}
